import { useState } from "react";
import { TypedFilter } from "odata-query";
import { taskService } from "@miplatform/api";
import { useComponentState } from "@miplatform/hooks";
import {
  IApiRequest,
  IWorkOrderTemplateListItemResponse,
  PlatformModules,
} from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getWorkOrderTemplatesUUID = createUUID();

export const useWorkOrderTemplates = ({
  debouncedSearch = "",
  module = null,
}: IUseWorkOrderTemplates = {}) => {
  const [workOrderTemplates, setWorkOrderTemplates] = useState<
    IWorkOrderTemplateListItemResponse[]
  >([]);
  const [recentWorkOrderTemplates, setRecentWorkOrderTemplates] = useState<
    IWorkOrderTemplateListItemResponse[]
  >([]);
  const [filter, setFilter] = useState<
    TypedFilter<IWorkOrderTemplateListItemResponse>
  >({});

  const stateManager = useComponentState();

  const getWorkOrderTemplates = ({ top, skip }: IApiRequest = {}) => {
    stateManager.abort(getWorkOrderTemplatesUUID);

    return stateManager.run(async () => {
      return taskService.workOrderTemplates.getAll({
        top,
        skip,
        filters: {
          ...filter,
          name: { contains: debouncedSearch },
          ...(module ? { module: { eq: module } } : {}),
        },
        sort: "name",
      });
    }, getWorkOrderTemplatesUUID);
  };

  const getRecentWorkOrderTemplates = ({
    sort,
    top,
    filters,
  }: IApiRequest = {}) => {
    return stateManager.run(async () => {
      return taskService.workOrderTemplates.getAll({
        sort,
        top,
        filters: {
          ...filter,
          ...filters,
          name: { contains: debouncedSearch },
          ...(module ? { module: { eq: module } } : {}),
        },
      });
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    setWorkOrderTemplates,
    workOrderTemplates,
    recentWorkOrderTemplates,
    setRecentWorkOrderTemplates,
    getWorkOrderTemplates,
    getRecentWorkOrderTemplates,
    filter,
    setFilter,
  };
};

interface IUseWorkOrderTemplates {
  debouncedSearch?: string;
  module?: PlatformModules | null;
}
